<!-- Hero Section with Two CTAs -->
<div class="w-full flex justify-center items-center bg-cover bg-center bg-no-repeat bg-[url('/assets/images/Group_69.webp')] min-h-[40vh] sm:h-[300px] relative px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="absolute inset-0 bg-black opacity-80"></div>
  <div class="text-center z-40 relative container mx-auto flex flex-col items-center gap-6 py-10">
    <h1 class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-2">Sell Your Tesla, Your Way</h1>
    <p class="sm:text-xl max-w-2xl mx-auto text-white mb-4">
      Need it sold yesterday? Grab a cash offer.<br class="hidden sm:inline" /> Want top dollar? List it on the #1 Tesla marketplace.
    </p>
    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <a routerLink="/your-tesla" class="bg-[#e50914] text-white font-semibold px-8 py-2.5 rounded-full shadow hover:bg-[#b0060f] transition-all text-lg">
        <span class="text-lg">+</span> Create New Listing
      </a>
      <!-- <a routerLink="/cash-offer" class="bg-[#ffc107] text-black font-semibold px-8 py-2.5 rounded-full shadow hover:bg-[#e0a800] transition-all text-lg flex items-center justify-center">
        Cash Offer
      </a> -->
    </div>
  </div>
</div>

<main class="bg-gradient-to-b from-gray-50 to-white px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div class="container mx-auto px-4 py-12 sm:px-6 sm:py-20">
    <!-- Headline -->
    <div class="text-center mb-10">
      <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">#1 Listing site for Teslas. Sell My Tesla Online — Fast, Secure, No Middlemen. <span class="block text-base font-normal text-gray-500">Since 2017.</span></h2>
    </div>

    <!-- Pricing Table -->
    <div class="grid gap-6 md:grid-cols-4 mb-12">
      <div class="bg-white rounded-2xl shadow px-6 py-8 flex flex-col items-center">
        <div class="rounded-full bg-blue-100 p-3 text-blue-600 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-megaphone-icon lucide-megaphone"><path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"/><path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"/><path d="M8 6v8"/></svg>
        </div>
        <div class="text-xl font-bold text-[#e50914] mb-1">Basic Ad</div>
        <ul class="text-gray-700 text-sm mb-1 list-disc list-inside">
          <li class="list-none">40 days, free CARFAX</li>
        </ul>
        <div class="font-extrabold opacity-80">$47</div>
      </div>
      <div class="bg-white rounded-2xl shadow px-6 py-8 flex flex-col items-center">
        <div class="rounded-full bg-green-100 p-3 text-green-600 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rocket-icon lucide-rocket"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>
        </div>
        <div class="text-xl font-bold text-[#e50914] mb-1">Boosted Ad</div>
        <ul class="text-gray-700 text-sm mb-1 list-disc list-inside">
          <li class="list-none">FB group exposure</li>
        </ul>
        <div class="font-extrabold opacity-80">+$100</div>
      </div>
      <div class="bg-white rounded-2xl shadow px-6 py-8 flex flex-col items-center">
        <div class="rounded-full bg-pink-100 p-3 text-pink-600 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-video-icon lucide-video"><path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>
        </div>
        <div class="text-xl font-bold text-[#e50914] mb-1">HD Video</div>
        <ul class="text-gray-700 text-sm mb-1 list-disc list-inside">
          <li class="list-none">HD video in your ad</li>
        </ul>
        <div class="font-extrabold opacity-80">+$25</div>
      </div>
      <div class="bg-white rounded-2xl shadow px-6 py-8 flex flex-col items-center">
        <div class="rounded-full bg-green-100  p-3 text-green-600 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-check-icon lucide-badge-check"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>
        </div>
        <div class="text-xl font-bold text-[#e50914] mb-1">Identity-Verified Badge</div>
        <ul class="text-gray-700 text-sm mb-1 list-disc list-inside">
          <li class="list-none">Get a verified badge with Stripe Identity</li>
        </ul>
        <div class="font-extrabold opacity-80">+$9</div>
      </div>
    </div>

    <!-- Why Us Section -->
    <div class="bg-white rounded-2xl shadow p-8 mb-12">
      <h3 class="text-2xl font-semibold text-gray-900 mb-4">Why Sellers Choose Us Over Generic Marketplaces</h3>
      <ul class="grid gap-4 md:grid-cols-2 text-gray-700">
        <li class="flex items-start gap-3"><span class="text-[#e50914] font-bold">•</span> We manage your ad. <span class="ml-1 text-xs bg-[#e50914] text-white px-2 py-0.5 rounded">NOT another listing site.</span></li>
        <li class="flex items-start gap-3"><span class="text-[#e50914] font-bold">•</span> 100+ Google reviews</li>
        <li class="flex items-start gap-3"><span class="text-[#e50914] font-bold">•</span> In Business since 2018</li>
        <li class="flex items-start gap-3"><span class="text-[#e50914] font-bold">•</span> Trusted by Tesla owners nationwide</li>
      </ul>
    </div>

    <!-- FAQ Accordion -->
    <div class="mb-12">
      <h3 class="text-2xl font-semibold text-gray-900 mb-6">Frequently Asked Questions</h3>
      <div>
        <details class="bg-white rounded-lg shadow p-4">
          <summary class="font-semibold cursor-pointer">How long is my ad live?</summary>
          <div class="mt-2 text-gray-700">40 days. Renew for 30 more days anytime for $25. Ads with a sale pending are temporarily exempt from expiration. You may cancel your ad at any time. No refunds after your ad is live and we print a CARFAX for you.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4 my-4">
          <summary class="font-semibold cursor-pointer">How do buyers reach me?</summary>
          <div class="mt-2 text-gray-700">Today: email or SMS (your number stays private). Coming soon: secure in-app chat.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4 my-4">
          <summary class="font-semibold cursor-pointer">Is my data safe?</summary>
          <div class="mt-2 text-gray-700">Our Stripe-powered ID-check verifies buyers/sellers. We never store your Tesla login or stay connected after exporting data.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4 my-4">
          <summary class="font-semibold cursor-pointer">Can I buy a refresh?</summary>
          <div class="mt-2 text-gray-700">Yes. If after 40 days your Tesla is not sold you can buy an ad refresh for $25.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4 my-4">
          <summary class="font-semibold cursor-pointer">What about fraud protection?</summary>
          <div class="mt-2 text-gray-700">You have an option to buy a Verification check for $9. We use STRIPE Identity for this.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4 my-4">
          <summary class="font-semibold cursor-pointer">How much can I sell my Tesla for?</summary>
          <div class="mt-2 text-gray-700">We check what similar cars are selling for or priced at with Tesla. The market price for a used Tesla is tied to the price volatility of a new Tesla. KBB will not cut you a check and does not account for new Tesla prices.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4 my-4">
          <summary class="font-semibold cursor-pointer">Best way to create an ad to sell your Tesla?</summary>
          <div class="mt-2 text-gray-700">Upload the software screen from inside your Tesla (shows FSD/autopilot status). Take lots of clear, high-quality photos, both close and wide shots.</div>
        </details>
        <details class="bg-white rounded-lg shadow p-4">
          <summary class="font-semibold cursor-pointer">What about my privacy / my password?</summary>
          <div class="mt-2 text-gray-700">We do not see or store your password. The password is not shown to us at all.</div>
        </details>
      </div>
    </div>

    <!-- Stripe Identity Badge & Privacy -->
    <div class="bg-white rounded-2xl shadow p-8 mb-12 flex flex-col md:flex-row items-center gap-8">
      <div class="flex-1">
        <h4 class="text-xl font-semibold text-gray-900 mb-2">Connect Your Tesla (Get a Verified Badge)</h4>
        <p class="text-gray-700 mb-2">We are approved by Tesla to use their official API. We connect to your Tesla, export the data for your ad, and then disconnect. You get a verified badge with Stripe Identity.</p>
        <ul class="text-gray-700 text-sm list-disc list-inside mb-2">
          <li>Primary owner name/email</li>
          <li>Vehicle spec, recent alerts, battery health, warranty</li>
          <li>Autopilot/FSD status</li>
        </ul>
        <p class="text-gray-700 text-sm">We do <span class="font-bold">NOT</span> stay connected to your Tesla. You can revoke access at any time.</p>
      </div>
      <div class="flex-shrink-0 flex flex-col items-center">
        <!-- <span class="inline-block bg-[#e50914] text-white px-4 py-2 rounded-full font-semibold mb-2">Verified Badge</span> -->
        <!-- <img src="/assets/images/stripe-identity-badge.png" alt="Stripe Identity Badge" class="w-24 h-24 object-contain" /> -->
      </div>
    </div>

    <!-- AI Agent Mention -->
    <div class="text-center text-gray-600 text-sm sm:text-base mt-8">
      <p>Are you building an AI agent? <a href="https://onlyusedtesla.ai/" class="text-blue-600 underline hover:text-blue-800">Check it out here - onlyusedtesla.ai</a> (Coming soon!)</p>
    </div>
  </div>
</main>
